import { inject, type ShallowRef } from 'vue';
import type { GrowthBook } from '@growthbook/growthbook';
import { FEATURE_FLAG_TOKEN } from '../config.ts';

export function useFeatureFlagInstance(): ShallowRef<GrowthBook> {
  const gb = inject<ShallowRef<GrowthBook>>(FEATURE_FLAG_TOKEN);
  if (!gb) {
    throw new Error(
      'FeatureFlag library not found, ensure FeatureFlagPlugin is installed',
    );
  }
  return gb;
}
